import { SettingOutlined } from "@ant-design/icons";
import { CrudOp, geometryAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { GeometryView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { brand }) => {
  const authHelper = authHelperCreator(geometryAuthScope);
  return brand != null && authHelper.evaluate(CrudOp.READ, brand);
};

export const geometryViewKey = "geometry_modular_geometry/:brand/:projectId/:subprojectId";
export const geometryViewModule: ViewModule = {
  viewKey: geometryViewKey,
  viewEl: <GeometryView/>,
  displayNameI18nKey: "geometry:geometryView.viewName",
  menuIconEl: <SettingOutlined/>,
  isAuthorized,
  translations,
};
